import type { SVGProps } from 'react';
const SvgStar1StreamlineCore = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" viewBox="-0.75 -0.75 20 20" {...props}>
    <desc>{'Star 1 Streamline Icon: https://streamlinehq.com'}</desc>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M9.897 1.44 12 5.682a.67.67 0 0 0 .541.397l4.639.687a.714.714 0 0 1 .396 1.229l-3.343 3.316a.7.7 0 0 0-.212.635l.806 4.664a.728.728 0 0 1-1.057.767L9.594 15.17a.78.78 0 0 0-.688 0l-4.175 2.207a.726.726 0 0 1-1.057-.767l.806-4.717a.7.7 0 0 0-.212-.634L.885 7.995a.714.714 0 0 1 .436-1.23L5.96 6.08a.67.67 0 0 0 .541-.397L8.602 1.44a.714.714 0 0 1 1.295 0"
    />
  </svg>
);
export default SvgStar1StreamlineCore;
